import {useState} from 'react';
import {getVimeoVideoId} from '../utils';
import {BlockContainer} from '../styled';

type Props = {
  url?: string;
};
export const VimeoEmbed = ({url}: Props) => {
  const [loading, setLoading] = useState(true);
  const videoId = getVimeoVideoId(url ?? '');
  const embedUrl = `https://player.vimeo.com/video/${videoId}`;

  return (
    <div>
      <BlockContainer>
        <iframe
          className={loading ? 'invisible h-0' : ''}
          onLoad={() => setLoading(false)}
          width="100%"
          height="315"
          src={embedUrl}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Vimeo video player"
        ></iframe>
      </BlockContainer>
    </div>
  );
};
